import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin } from "lucide-react";
const TocTocFooter = () => {
  // Use current year directly to prevent hydration mismatch
  const currentYear = new Date().getFullYear();

  return <footer className="bg-[#323031] text-gray-300">
      <div className="container max-w-7xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <img src="/lovable-uploads/24e0e29e-3e10-43db-8be9-1cc4bc18ab2f.png" alt="TocToc Logo" loading="lazy" width="114" height="64" className="h-14 mb-4 brightness-0 invert" />
            <p className="mb-4">
              Fotografia profissional especializada em imóveis para acelerar vendas e maximizar valor.
            </p>
            <div className="flex space-x-4">
              <a href="https://www.instagram.com/toctoc.br?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="hover:text-[#FF5605] transition-colors" aria-label="Instagram">
                <Instagram size={20} strokeWidth={1.5} />
              </a>
              <a href="#" className="hover:text-[#FF5605] transition-colors" aria-label="Facebook">
                <Facebook size={20} strokeWidth={1.5} />
              </a>
              <a href="#" className="hover:text-[#FF5605] transition-colors" aria-label="LinkedIn">
                <Linkedin size={20} strokeWidth={1.5} />
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold text-white mb-4">Empresa</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/sobre" className="hover:text-[#FF5605] transition-colors">
                  Sobre nós
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-[#FF5605] transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/contato" className="hover:text-[#FF5605] transition-colors">
                  Contato
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold text-white mb-4">Suporte</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/centraldeajuda" className="hover:text-[#FF5605] transition-colors">
                  Central de Ajuda
                </Link>
              </li>
              <li>
                <Link to="/termos" className="hover:text-[#FF5605] transition-colors">
                  Termos de Serviço
                </Link>
              </li>
              <li>
                <Link to="/privacidade" className="hover:text-[#FF5605] transition-colors">
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link to="/faq" className="hover:text-[#FF5605] transition-colors">
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Geographic SEO Section */}
        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="text-center mb-6">
            <h4 className="font-semibold text-white mb-3">Cidades Atendidas - Fotografia Imobiliária em Santa Catarina</h4>
            <address className="not-italic text-gray-400 leading-relaxed">
              Atendemos fotografia imobiliária e vídeos de imóveis em:{" "}
              <Link to="/cidades-atendidas" className="text-[#FF5605] hover:underline">
                Balneário Camboriú, Camboriú, Itajaí, Itapema, Porto Belo, Bombinhas, Navegantes
              </Link>
              {" "}e toda região litorânea de Santa Catarina. 
              Fotografia de arquitetura, fotografia de interiores e marketing imobiliário para SC.
            </address>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-sm">
          <p>&copy; {currentYear} Toc Toc Fotografia Imobiliária. Todos os direitos reservados.</p>
          <p className="mt-4 md:mt-0">
            📍 Base: Balneário Camboriú, SC | 📞 (47) 99736-7396
          </p>
        </div>
      </div>
    </footer>;
};
export default TocTocFooter;